import React from 'react';
interface Props {
  fillColor?: string;
}
function OsteopathyIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="17"
      viewBox="0 0 10 17"
      fill="none">
      <g clipPath="url(#clip0_851_3418)">
        <path
          d="M4.9997 3.25C5.19862 3.25 5.38938 3.17098 5.53004 3.03033C5.67069 2.88968 5.7497 2.69891 5.7497 2.5C5.7497 2.30109 5.67069 2.11032 5.53004 1.96967C5.38938 1.82902 5.19862 1.75 4.9997 1.75C4.80079 1.75 4.61003 1.82902 4.46937 1.96967C4.32872 2.11032 4.2497 2.30109 4.2497 2.5C4.2497 2.69891 4.32872 2.88968 4.46937 3.03033C4.61003 3.17098 4.80079 3.25 4.9997 3.25ZM4.9997 0.25C5.59644 0.25 6.16874 0.487053 6.59069 0.90901C7.01265 1.33097 7.2497 1.90326 7.2497 2.5C7.2497 3.09674 7.01265 3.66903 6.59069 4.09099C6.16874 4.51295 5.59644 4.75 4.9997 4.75C4.40297 4.75 3.83067 4.51295 3.40871 4.09099C2.98676 3.66903 2.7497 3.09674 2.7497 2.5C2.7497 1.90326 2.98676 1.33097 3.40871 0.90901C3.83067 0.487053 4.40297 0.25 4.9997 0.25ZM3.9997 6.9375V10.75H5.9997V6.95C5.68095 6.81875 5.3372 6.75 4.98721 6.75C4.64346 6.75 4.3122 6.81563 3.9997 6.9375ZM3.9997 12.25V15.5C3.9997 15.9156 3.66533 16.25 3.2497 16.25C2.83408 16.25 2.4997 15.9156 2.4997 15.5V8.30937L1.36533 9.93125C1.12783 10.2719 0.65908 10.3531 0.32158 10.1156C-0.0159201 9.87813 -0.10342 9.40938 0.13408 9.06875L1.56533 7.03125C2.34658 5.91563 3.62471 5.25 4.98721 5.25C6.3372 5.25 7.60283 5.9 8.38721 7L9.85908 9.0625C10.0997 9.4 10.0216 9.86875 9.68408 10.1094C9.34658 10.35 8.87783 10.2719 8.63721 9.93437L7.4997 8.34062V15.5C7.4997 15.9156 7.16533 16.25 6.7497 16.25C6.33408 16.25 5.9997 15.9156 5.9997 15.5V12.25H3.9997Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3418">
          <rect
            width="10"
            height="16"
            fill="white"
            transform="translate(0 0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OsteopathyIcon;
